// TODO: move to playback
import {
  type OpenSessionHistoryAction,
  type SetSessionHistoryIndexAction,
  type ToggleTprTextAction,
} from 'src/types';

import * as Constants from '../constants';
import { ApiActions } from '../constants/ApiActions';
import { NowPlayingKeys } from '../constants/NowPlaying';
import ViewActions from '../constants/ViewActions';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [NowPlayingKeys.SESSION_HISTORY_INDEX_KEY]: 1,
  [NowPlayingKeys.IS_SESSION_HISTORY_OPEN_KEY]: false,
  [NowPlayingKeys.IS_NOW_PLAYING_OPEN_KEY]: false,
  [NowPlayingKeys.IS_UPDATING_FEEDBACK_KEY]: false,
  [NowPlayingKeys.IS_TPR_TEXT_FADED]: false,
  [NowPlayingKeys.IS_MARKING_TRACK_AS_TIRED]: false,
});
export type NowPlayingState = typeof INITIAL_STATE;

// NOWPLAYING REDUCER
export default createReducer(INITIAL_STATE, {
  [ViewActions.OPEN_SESSION_HISTORY]: openSessionHistory,
  [ViewActions.TOGGLE_TPR_TEXT]: toggleTprText,
  [ViewActions.CLOSE_SESSION_HISTORY]: closeSessionHistory,
  [ViewActions.OPEN_NOW_PLAYING]: openNowPlaying,
  [ViewActions.CLOSE_NOW_PLAYING]: closeNowPlaying,
  [ViewActions.SET_SESSION_HISTORY_INDEX]: setSessionHistoryIndex,
  [ApiActions.ADD_TIRED_SONG_ATTEMPT]: addTiredSongAttempt,
  [ApiActions.ACTION_SNOOZE_ATTEMPT]: addTiredSongAttempt,
  [Constants.Playback.ActionTypes.TIRE_OF_TRACK]: tireOfTrack,
  [ApiActions.FLAG_MESSAGE_ATTEMPT]: updatingFeedback,
  [ApiActions.FLAG_MESSAGE_SUCCESS]: updatedFeedback,
  [ApiActions.FLAG_MESSAGE_FAIL]: updatedFeedback,
  [Constants.UseCases.ActionTypes.ADD_TRACK_FEEDBACK]: updatingFeedback,
  [Constants.UseCases.ActionTypes.REMOVE_TRACK_FEEDBACK]: updatingFeedback,
  [Constants.Playback.ActionTypes.TRACK_THUMBUP]: updatingFeedback, // Needed for transforming shared station optimistic UI
  [Constants.Playback.ActionTypes.TRACK_THUMBDOWN]: updatingFeedback, // Needed for transforming shared station optimistic UI
  [ApiActions.DELETE_FEEDBACK_SUCCESS]: updatedFeedback,
  [ApiActions.DELETE_FEEDBACK_FAIL]: updatedFeedback,
  [ApiActions.ADD_FEEDBACK_SUCCESS]: updatedFeedback,
  [ApiActions.ADD_FEEDBACK_FAIL]: updatedFeedback,
  [ApiActions.ACTION_THUMB_UP_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_THUMB_UP_FAIL]: updatedFeedback,
  [ApiActions.ACTION_THUMB_DOWN_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_THUMB_DOWN_FAIL]: updatedFeedback,
  [ApiActions.ACTION_REMOVE_THUMB_SUCCESS]: updatedFeedback,
  [ApiActions.ACTION_REMOVE_THUMB_FAIL]: updatedFeedback,
});

// CASE FUNCTIONS

function openSessionHistory(
  state: NowPlayingState,
  { payload }: OpenSessionHistoryAction,
): NowPlayingState {
  return state.merge({
    [NowPlayingKeys.IS_SESSION_HISTORY_OPEN_KEY]: true,
    [NowPlayingKeys.SESSION_HISTORY_INDEX_KEY]: payload.historySize - 2,
  });
}

function toggleTprText(state: NowPlayingState, { payload }: ToggleTprTextAction): NowPlayingState {
  return state.set(NowPlayingKeys.IS_TPR_TEXT_FADED, payload.isFaded);
}

function closeSessionHistory(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_SESSION_HISTORY_OPEN_KEY, false);
}

function openNowPlaying(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_NOW_PLAYING_OPEN_KEY, true);
}

function closeNowPlaying(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_NOW_PLAYING_OPEN_KEY, false);
}

function setSessionHistoryIndex(
  state: NowPlayingState,
  { payload }: SetSessionHistoryIndexAction,
): NowPlayingState {
  return state.set(NowPlayingKeys.SESSION_HISTORY_INDEX_KEY, payload.sessionHistoryIndex);
}

function addTiredSongAttempt(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_MARKING_TRACK_AS_TIRED, true);
}

function tireOfTrack(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_MARKING_TRACK_AS_TIRED, false);
}

function updatingFeedback(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_UPDATING_FEEDBACK_KEY, true);
}

function updatedFeedback(state: NowPlayingState): NowPlayingState {
  return state.set(NowPlayingKeys.IS_UPDATING_FEEDBACK_KEY, false);
}
